// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c67fb7e2","513":"f3cd0c77","787":"e6133489"}[chunkId] + ".chunk.js";
};